export const ROWS_PER_PAGE = 20;

export const getPageNo = (offset: number): number => {
  return offset / ROWS_PER_PAGE + 1;
};

export const getOffset = (pageNo: number): number => {
  return (pageNo - 1) * ROWS_PER_PAGE;
};
